import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M14.8885 2C17.3776 2 18.6231 1.99954 19.5738 2.46666C20.4099 2.87752 21.09 3.53331 21.5161 4.33956C22.0005 5.25633 22 6.45734 22 8.85756V10.1424C22 12.5427 22.0005 13.7437 21.5161 14.6604C21.09 15.4667 20.4099 16.1225 19.5738 16.5333C18.6231 17.0005 17.3776 17 14.8885 17H9.11154C6.62242 17 5.37693 17.0005 4.42622 16.5333C3.5901 16.1225 2.91002 15.4667 2.48394 14.6604C1.99953 13.7437 2 12.5427 2 10.1424V8.85756C2 6.45734 1.99953 5.25633 2.48394 4.33956C2.91002 3.53331 3.5901 2.87752 4.42622 2.46666C5.37693 1.99954 6.62242 2 9.11154 2H14.8885ZM10.3333 12.2832L15.3333 9.5L10.3333 6.7168V12.2832Z'
            fill='currentColor'
        />
        <path d='M4 19L5.73205 22H2.26795L4 19Z' fill='currentColor' />
        <path d='M12 19L13.7321 22H10.2679L12 19Z' fill='currentColor' />
        <path d='M20 19L21.7321 22H18.2679L20 19Z' fill='currentColor' />
        <path d='M4.5 21.25H20.5' stroke='currentColor' strokeWidth='1.5' />
    </svg>
);

export const VideoIcon = styled(Icon)({});
